<template lang="pug">
.custom-table
  table.table.table-striped
    thead
      tr
        th(v-if='showNotificationDots' style=`text-align: center`)
        th(v-if='selectable' style=`text-align: center`)
        th(v-if='showIndexes' style=`text-align: center`)
          | ลำดับ
        th(
          scope='col'
          v-for='(col, key) in columns'
          :class="{'is-sortable': col.sortable}"
          @click="(col.sortable) ? $emit('sort', key) : ''"
          :key='key'
        )
          div(:style="`text-align: ${col.align}`")
            | {{ col.title }}
            InfoTooltip.sm(
              v-if="col.type === 'EntryNo'"
              info="เลขที่มีสัญลักษณ์ # และเป็นตัวเอียงคือเลขที่รายการขั่วคราวก่อนเปิดบิลจริง"
            )
            span.ml-2(v-if="col.sortable") ▾
        //- th(scope='col') #
        //- th(scope='col') 1
        //- th(scope='col') 2
        //- th(scope='col') 3
        th(v-if="!!$slots.endTableSlot") &nbsp;
    tbody
      template(v-for='(row, i) in data')
        tr.data-row(
          :class='itemClickable ? `transparent-button no-scaling`:``'
        )
          //- @click='onItemClicked(row, i)'
          template(v-if='showNotificationDots')
            td.pl-3.text-center(@click='onRowClicked(row, i)')
              .notification-dot.mt-1(v-if='row.updated')
          template(v-if='selectable')
            td.text-center(@click='onRowClicked(row, i)')
              //- input(type='checkbox' :checked='selectedItemsIndex.includes(i)')
              .check-container(:class="{'is-active': selectedItemsIndex .includes(i)}")
                .check
          td(v-if='showIndexes' style=`text-align: center;`)
            //- | {{ startIndex + i }}
            //- ขอบคุณสำหรับ effort การ dev นะ
            //- แต่เลขลำดับนี้จะเป็น 1 - 30 เสมอ ไม่ว่าจะเปลี่ยนหน้ายังไงก็ตาม
            | {{ i + 1 }}
          td(
            v-for='(col, key) in columns'
            :key='key'
            :style="`text-align: ${col.align};`"
            v-html='renderData(row, i, col, key)'
            @click='onRowClicked(row, i, col)'
          )
          //- th(scopr='row') 1
          //- td Mark
          //- td Otto
          //- td @mdo
          td
            .end-table-slot
              slot(name="endTableSlot" :rowData="{ row: row, index: i }")

  template(v-if='showEmptyStateMessage === true && (!data || data.length === 0)')
    .text-medium.d-flex.justify-content-center.py-4
      | {{ emptyStateMessage }}
</template>

<script>
export default {
  props: {
    columns: {
      // default: {
      //   customerName: {
      //     title: 'ชื่อลูกค้า',
      //     align: 'left',
      //   },
      //   total: {
      //     title: 'ยอดรวม',
      //     align: 'right',
      //     type: Number,
      //   },
      //   xxx: {
      //     title: 'xxx',
      //     align: 'right',
      //     type: Date,
      //   },
      // },
      default: () => {},
    },
    data: {
      // default: [
      //   {
      //     customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
      //     total: 69000.46,
      //   },
      // ],
      default: () => [],
    },
    showIndexes: {
      default: true,
    },
    showNotificationDots: {
      default: false,
    },
    selectable: {
      default: false,
    },
    itemClickable: {
      default: true,
    },
    value: {
      default: () => [],
    },
    startIndex: {
      default: 1,
      validator: () => { console.warn('startIndex is deprecated, consirder remove / don\'t implement'); return true; },
    },

    emptyStateMessage: {
      default: 'ยังไม่มีข้อมูล',
    },
    showEmptyStateMessage: {
      default: true,
    },
  },
  watch: {
    value(newVal) {
      this.selectedItemsIndex = newVal;
    },
  },
  data: () => ({
    selectedItemsIndex: [],
  }),
  mounted() {
    this.selectedItemsIndex = this.value;
  },
  methods: {
    renderData(row, i, col, colKey) {
      if (col.computed) {
        return this.formatData(col.computed(row, i), row, col.type);
      }
      return this.formatData(row[colKey], row, col.type);
    },
    formatData(value, row, type) {
      // prevent human coding error (undefined type matched with undefined case)
      if (!type) {
        return value;
      }

      if (type === 'EntryNo') { // overriding display of EntryNo
        if ('combinedId' in row) {
          const [unix, internal] = row.combinedId.split('/');
          if (!unix || unix === 'null' || unix === '') {
            return `<i style="opacity: 0.65">#${internal}</i>`;
          }
          // return `${unix} <i><small style="opacity: 0.65;">(#${internal})</small></i>`;
          return `${unix}`; // hide # if has unix (K' Mu requested)
        }
        return value; // if didn't specify combinedId, return entryNo
      }

      // console.log('format');
      // console.log(row);

      const { COL_TYPE } = this.$api.customer;
      const { COL_TYPE: COL_TYPE_PRODUCT } = this.$api.product;
      const { COL_TYPE: COL_TYPE_PERMISSIONS } = this.$api.admin.permissions; // starts with 100
      const COL_TYPE_CONTROLS = {
        Button: 'Controls.BUTTON',
        Switch: 'Controls.SWITCH',
        NotificationDot: 'Controls.NOTIFICATION_DOT',
      };

      const ORDER_STATUS_TEXT = {
        0: 'รออนุมัติ',
        1: 'อนุมัติ',
        2: 'ไม่อนุมัติ',
        3: 'UNIX',
        9: 'ใบเสนอราคา',
      };
      const SHIPMENT_STATUS_TEXT = {
        0: 'รอจัดส่ง',
        1: 'จัดส่งแล้ว',
        2: 'ไม่อนุมัติ', // unused
      };
      const BACKORDER_STATUS_TEXT = {
        0: 'รอสินค้า',
        1: 'พร้อม',
        2: 'ยกเลิก',
      };
      const PERMISSION_LEVEL_TEXT = {
        0: 'เซลล์',
        1: 'CS',
        2: 'Approver',
        3: 'Admin',
      };

      switch (type) {
        case Number:
          return parseFloat(value).toFixed(2).replace(/\B(?=(?=\d*\.)(\d{3})+(?!\d))/g, ',');
        case Date:
          if (value) {
            return this.$moment(value).format('Do/MM/YYYY');
          }
          return '-';
        case COL_TYPE.Time:
          return this.$moment(value).format('HH:mm');
        case COL_TYPE.OrderStatus:
          return `
            <div class='order-status status-${value}'>${ORDER_STATUS_TEXT[value]}</div>
          `;
        case COL_TYPE.ShipmentStatus:
          return `
            <div class='order-status status-${value}'>${SHIPMENT_STATUS_TEXT[value]}</div>
          `;
        case COL_TYPE.BackOrderStatus:
          return `
            <div class='order-status status-${value}'>${BACKORDER_STATUS_TEXT[value]}</div>
          `;
        case COL_TYPE_PRODUCT.Amount:
          return value;
        case COL_TYPE_PERMISSIONS.PermissionLevels:
          return `
            <div class='permission-level level-${value}'>${PERMISSION_LEVEL_TEXT[value]}</div>
          `;
        case COL_TYPE_CONTROLS.Switch:
          return `
            <div class="custom-control custom-switch large">
              <input type="checkbox" class="custom-control-input" id="customSwitch1" ${value === true ? 'checked' : ''}>
              <label class="custom-control-label" for="customSwitch1"></label>
            </div>
          `;
        case COL_TYPE_CONTROLS.Button:
          if (value === '') return '';
          return `
            <button class='btn btn-sm btn-light px-3' style='border-radius: 20px; color: #0092C9;'>
              ${value}
            </div>
          `;
        case COL_TYPE_CONTROLS.NotificationDot:
          if (value === true) {
            return '<div class="notification-dot ml-auto" />';
          }
          return '';
        default:
          return value;
      }
    },
    onRowClicked(row, i, col = {}) { // eslint-disable-line
      // if (col.type === 'Controls.BUTTON') {
      //   if ('computed' in col && col.computed(row) === '') {
      //     console.warn('Disabled onRowClicked because value is none; CustomTable');
      //     return '';
      //   }
      // }
      if (col && col.onClick) {
        const everythingHandled = col.onClick(row);
        // alert(everythingHandled);
        if (everythingHandled === false) {
          this.$emit('itemClicked', { index: i, data: row });
        }
      } else {
        if (this.selectable === true) {
          const arrIndex = this.selectedItemsIndex.indexOf(i);
          // console.log(arrIndex);
          if (arrIndex !== -1) {
            this.selectedItemsIndex.splice(arrIndex, 1);
          } else {
            this.selectedItemsIndex.push(i);
          }
          // console.log(this.selectedItemsIndex);
          this.$emit('input', this.selectedItemsIndex);
        }
        this.$emit('itemClicked', { index: i, data: row });
      }
    },
  },
};
</script>

<style lang="scss">
.custom-table {
  td {
    vertical-align: middle;
  }
  tr.data-row {
    .end-table-slot {
      opacity: 0;
      pointer-events: none;
      transition: all 0.05s;
    }
    &:hover {
      .end-table-slot {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
  th.is-sortable {
    cursor: pointer;
    &:hover {
      background-color: rgba(#EBF3F8, 0.75);
    }
  }
}
</style>
